export const FirearmSerialTypeConstants = {
  BARREL_SERIAL_NUMBER: 'f48c9249-9afb-47d6-a16e-ee004460b6af',
  BARREL_AND_RECEIVER_FRAME_SERIAL_NUMBER: '34e83596-829d-4a32-be17-3dda968c0104',
  RECEIVER_FRAME_SERIAL_NUMBER: '8006aa4b-d2d9-42ab-9ab5-f2a1281dd946',
};
